import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import { NewAgentsRotationCriteriaRoutes } from "../../../routes/HomeRoutes/NewAgentsRotationCriteriaRoutes";

export const NewAgentsRotationCriteriaLayout = () => (
  <SwitchRoute routes={NewAgentsRotationCriteriaRoutes} />
);
